module.exports = __webpack_public_path__ + "static/img/Query.c73e0c97.png";